// --------------------------------------------------------------------------
// #97 – ASK DOCUMENT MODULE
// --------------------------------------------------------------------------
// Author:      Alex Baulch
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');
var ModalDisplay = require('./modal');
var modalDisplay = new ModalDisplay();

module.exports = function (options) {
    var context = options.context;

    function init() {

        context.each(function () {
            var externalExists = false;
            var thisContext = $(this);
            if (!externalExists) {
                externalExists = true;
                modalDisplay.externalModal(thisContext, thisContext.find('[data-binding="modal"]'), 'ask');
            }

            if (window.location.hash === '#ask-document-modal') {
                thisContext.find('.info').trigger('click');
            }
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/ask-document-block.js
// module id = 198
// module chunks = 0